import React from 'react';
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

const SearchResult = function ({entity}) {
    const items = useSelector(state => state[entity]);
    const total = useSelector(state => state[entity + '_total']);

    return (
        <div>
            Displaying {items.length} out of {total}
        </div>
    );
}

SearchResult.propTypes = {
    entity: PropTypes.string.isRequired
};

export default SearchResult;
